import { __extends } from "tslib";
import { isNumber } from '@antv/util';
import Base from '../base';
/**
 * identity scaleååä¸æ¯å®ä¹ååå¼åä¸è´ï¼scale/invertæ¹æ³ä¹æ¯ä¸è´ç
 * åèRçå®ç°ï¼https://github.com/r-lib/scales/blob/master/R/pal-identity.r
 * åèd3çå®ç°ï¼åäºä¸è½¬åï¼ï¼https://github.com/d3/d3-scale/blob/master/src/identity.js
 */
var Identity = /** @class */ (function (_super) {
    __extends(Identity, _super);
    function Identity() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'identity';
        _this.isIdentity = true;
        return _this;
    }
    Identity.prototype.calculateTicks = function () {
        return this.values;
    };
    Identity.prototype.scale = function (value) {
        // å¦æä¼ å¥çå¼ä¸ç­äº identity çå¼ï¼åç´æ¥è¿åï¼ç¨äºä¸ç»´å¾æ¶ç dodge
        if (this.values[0] !== value && isNumber(value)) {
            return value;
        }
        return this.range[0];
    };
    Identity.prototype.invert = function (value) {
        var range = this.range;
        if (value < range[0] || value > range[1]) {
            return NaN;
        }
        return this.values[0];
    };
    return Identity;
}(Base));
export default Identity;
//# sourceMappingURL=index.js.map